import React from 'react';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ShareBtn from '../ShareBtn';
import Score from '../JustifiedData/Score';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { useHistory, useIntl } from 'umi';
import { useFeedsCommentList } from '../../hooks';
import { sentimentTypeMap } from '@/pages/opinion/components/ReviewsModal/constants';
import ChannelLabel from '@/pages/opinion/components/ChannelLabel';
import { goToFeedsReviewsDetail } from '@/pages/opinion/utils/url';
import {
  useDrilldownParams,
  EDrilldownMode,
} from '@op/hooks/useDrilldownParams';
import { MetacriticScore } from '@/pages/opinion/components/MetacriticScore';
import SteamRatingColumns from '@/pages/opinion/components/SteamRatingColumns';
import { getContentInfo } from '../../utils.ts';
import { LanguageType } from '@/pages/opinion/types/common';
import { getFilterValueStorage } from '@op/components/FilterCommon/utils/storage';
import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import { Bubble, Button } from 'tea-component';

const tabMap: any = {
  social: 'socialMedia',
  comments: 'gameStore',
};

const ContextualNearbyReviews = ({
  data,
  loading,
  empty,
  gameInfo,
  language,
  isShowSentiment = true,
  feedsSource,
}: {
  data: any;
  loading: boolean;
  empty: boolean;
  gameInfo: any;
  language: LanguageType;
  isShowSentiment: boolean;
  feedsSource?: string;
}) => {
  const { formatMessage } = useIntl();
  const { Sentiment_Update } = useGetSingePageSourceRule({
    keys: 'Sentiment_Update',
  });
  const {
    commentList,
    loading: commentLoading,
    empty: commentEmpty,
  } = useFeedsCommentList({
    gameInfo,
    id: data?.comment_uin,
    endTime: data?.comment_time,
    feedsSource,
  });

  const getChannelElement = (data: any) => {
    const type = data.channel_name;
    const elementMap: any = {
      metacritic: <MetacriticScore isColumns={false} data={data} />,
      opencritic: <MetacriticScore isColumns={false} data={data} />,
      steam: (
        <SteamRatingColumns {...data} isColumns={false}></SteamRatingColumns>
      ),
      'google play': <Score data={data} />,
      'app store': <Score data={data} />,
      taptap: <Score data={data} />,
    };
    const showElement = elementMap[type];
    if (showElement) {
      return <div className="dbo-contextual-score">{showElement}</div>;
    }
    return null;
  };

  const history = useHistory();
  const { goPage } = useDrilldownParams();

  const gotoFeeds = () => {
    const {
      channel_type,
      channel_name,
      keyword_or_account,
      keyword_account_name,
    } = data;
    const tab = tabMap?.[channel_type] || 'socialMedia';
    const filterValue = getFilterValueStorage(gameInfo);
    let params: any = {
      ...filterValue,
      statsDetailType: 'feeds-ReviewDetail',
      channel: [channel_name],
      channel_type: channel_type,
      social_media_by_account: ['99999'],
      feed_source: feedsSource,
    };

    if (keyword_or_account === 'account') {
      params['social_media_by_account'] = [keyword_account_name];
    }

    goPage({
      path: `/opinion/Feeds/Feeds?tab=${tab}`,
      filter: params,
      mode: EDrilldownMode.Local,
    });
  };

  return (
    <CardCommon
      loading={loading || commentLoading}
      loadingHeight={260}
      emptyHeight={260}
      empty={empty || commentEmpty}
      className="dbo-contextual-nearby"
      cardHeaderElement={
        <div className="dbo-nearby-header">
          <div className="dbo-nearby-title" onClick={gotoFeeds}>
            <ChannelLabel
              showText={false}
              channel_name={data?.channel_name}
              iconClassName="dbo-nearby-img"
            ></ChannelLabel>
            <span className="dbo-nearby-text">
              {formatMessage({ id: 'Contextual Nearby Reviews' })}
            </span>
            <SvgIcon type="arrow-right" className="dbo-nearby-icon" />
          </div>
          <div className="dbo-nearby-sbutitle">
            {formatMessage({
              id: 'Display 20 reviews from the same Official Account (if any)',
            })}
          </div>
        </div>
      }
    >
      <>
        {commentList?.map((e: any) => {
          const isMain = e.comment_uin === data.comment_uin;
          return (
            <div
              className={`dbo-contextual-item ${isMain ? 'action' : ''}`}
              key={e.comment_uin}
            >
              <div className="dbo-contextual-message">
                <div className="dbo-contextual-lable">
                  {!Sentiment_Update && (
                    <SvgIcon
                      type={sentimentTypeMap[e.sentiment_rating]}
                      className="dbo-contextual-svg"
                    />
                  )}
                  <span className="dbo-lable-text">{e.reviewer}</span>
                  <span>{e.comment_time}</span>
                </div>
                {isMain && (
                  <span className="dbo-contextual-message-tips">
                    {formatMessage({
                      id: 'The current position of this review',
                    })}
                  </span>
                )}
                <Bubble
                  closeOnScroll
                  content={formatMessage({ id: 'View details' })}
                  dark
                >
                  <Button className="dbo-feeds-btn" type="link">
                    <SvgIcon
                      type="view-details-icon"
                      className="dbo-feeds-btn-icon"
                      onClick={() =>
                        goToFeedsReviewsDetail(history, e, { language })
                      }
                    />
                  </Button>
                </Bubble>
                <ShareBtn data={e} text={''} />
              </div>
              <div
                className={`dbo-contextual-text ${!isMain ? 'active' : ''}`}
                onClick={() => {
                  !isMain && goToFeedsReviewsDetail(history, e, { language });
                }}
              >
                {getContentInfo(e, language, isShowSentiment)}
              </div>
              {getChannelElement(e)}
            </div>
          );
        })}
      </>
    </CardCommon>
  );
};

export default ContextualNearbyReviews;
